import Immutable from 'immutable';
import AuthConstants from '../constants/AuthConstants';

const initialState = Immutable.Map({
  currentUserId: null,
  loginError: null,
  loginDialogOpen: false,
  postLoginAction: null,
  loading: false
});

function sendStatusUpdate(status) {
  // Notify the header
  if (__CLIENT__ && window.BCHeaderPublic) {
    window.BCHeaderPublic('sessionChanged');
  }

  // When in iframe mode, post a message to the parent with the current status
  if (__CLIENT__ && typeof window.parentIFrame !== 'undefined') {
    const postMessagePayload = {
      userLoggedIn: status,
      name: window.name
    };

    window.parentIFrame.sendMessage(postMessagePayload, '*');
  }
}

export default function auth(state = initialState, action) {
  const actionError = action.payload?.error;

  // Automatically open the login dialog, when an action fails because the user's session expired.
  if (action.sessionExpired) {
    sendStatusUpdate(false);
    return state.merge({
      loginError: actionError,
      currentUserId: null,
      loginDialogOpen: true,
      postLoginAction: action.payload.postLoginAction
    });
  }

  switch (action.type) {
    case AuthConstants.AUTH_LOAD_USER_FAILURE: {
      return initialState;
    }

    case AuthConstants.AUTH_LOAD_USER_SUCCESS: {
      return state.merge(action.payload.auth);
    }

    case AuthConstants.AUTH_LOGIN_REQUEST: {
      return state.merge({
        loading: true
      });
    }

    case AuthConstants.AUTH_LOGIN_SUCCESS: {
      sendStatusUpdate(true);
      return state.merge({
        currentUserId: action.payload.auth.currentUserId,
        loginError: null,
        loginDialogOpen: false,
        loading: false
      });
    }

    case AuthConstants.AUTH_LOGIN_ERROR: {
      sendStatusUpdate(false);
      return state.merge({
        currentUserId: null,
        loginError: actionError,
        loginDialogOpen: true,
        loading: false
      });
    }

    case AuthConstants.AUTH_LOGOUT: {
      sendStatusUpdate(false);
      return initialState;
    }

    case AuthConstants.OPEN_LOGIN_DIALOG: {
      return state.merge({
        currentUserId: null,
        loginDialogOpen: true,
        loginError: actionError,
        postLoginAction: action.payload.postLoginAction
      });
    }

    case AuthConstants.CLOSE_LOGIN_DIALOG: {
      return state.merge({
        loginError: null,
        loginDialogOpen: false,
        postLoginAction: null
      });
    }

    default:
      return state;
  }
}
